import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { signInWithCustomToken } from "firebase/auth";
import { auth } from "../lib/firebase";
import { Spinner } from "../components/common";

/* /auth/sso-complete — landing page for the backend-driven SocialPulse SSO flow.
   The backend has already exchanged the OIDC code and minted a Firebase custom
   token; we finish the sign-in on the client and navigate to return_to. */
export default function SsoComplete() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [err, setErr] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    // Clear the SsoRecoveryBanner marker — the flow completed successfully.
    try { sessionStorage.removeItem("sp_sso_pending"); } catch { /* ignore */ }
    const token = params.get("token");
    const returnTo = params.get("return_to") || "/";
    if (!token) { setErr("Missing sign-in token"); return; }
    signInWithCustomToken(auth, token)
      .then(() => nav(returnTo.startsWith("/") && !returnTo.startsWith("//") ? returnTo : "/", { replace: true }))
      .catch((e) => setErr(e?.message || "Sign-in failed"));
  }, [params, nav]);

  if (err) {
    return (
      <div className="min-h-[50vh] grid place-items-center p-6" data-testid="sso-complete-error">
        <div className="max-w-md text-center">
          <div className="text-[10px] font-mono uppercase tracking-[0.28em] text-rose-600 mb-2">Sign-in issue</div>
          <p className="text-slate-800">{err}</p>
          <button onClick={() => nav("/login", { replace: true })} className="mt-4 px-4 py-2 bg-emerald-600 text-white rounded-full text-sm font-700">
            Back to sign in
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="min-h-[50vh] grid place-items-center" data-testid="sso-complete-loading">
      <Spinner label="Finishing sign in…" />
    </div>
  );
}
